import { useSelector, useDispatch } from 'react-redux';
import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  views: [],
};

const addExpandView = (state, action) => {
  return [...new Set([...state.views, action.payload])];
};

const removeExpandView = (state, action) => {
  return state.views.filter((view) => view !== action.payload);
};

export const expandViewsSlice = createSlice({
  name: 'expandViews',
  initialState,
  reducers: {
    expand: (state, action) => {
      state.views = addExpandView(state, action);
    },
    collapse: (state, action) => {
      state.views = removeExpandView(state, action);
    },
    toggle: (state, action) => {
      if (state.views.includes(action.payload))
        state.views = removeExpandView(state, action);
      else state.views = addExpandView(state, action);
    },
  },
});

export const { expand, collapse, toggle } = expandViewsSlice.actions;

export const expandViewsReducer = expandViewsSlice.reducer;

const expandedViewsSelector = createSelector(
  (state) => state.expandViews,
  (state) => state.views
);

export const useExpandView = ({ view }) => {
  const dispatch = useDispatch();
  const expandedViews = useSelector(expandedViewsSelector);

  const isExpanded = expandedViews?.includes(view);

  const toggle = () => {
    dispatch(expandViewsSlice.actions.toggle(view));
  };

  const collapse = () => {
    dispatch(expandViewsSlice.actions.collapse(view));
  };

  return { isExpanded, toggle, collapse };
};

export const EXPAND_VIEWS = {
  MEMBER_BILLING_TAB: 'MEMBER_BILLING_TAB',
};
